import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { APIURLs } from '../api-urls';
import { map, catchError } from 'rxjs/operators';
import { SharedService } from '../shared/shared.service';
import { environment } from 'src/environments/environment';

/** Service Injectable */
@Injectable({
  providedIn: 'root'
})
export class OnboardingService {

  /**
   * Method to initialize Service
   * @param http instance of HttpClient
   * @param urls instance of APIURLs
   * @param shared instance of SharedService
   */
  /* save kyc process  loader*/
  private kycLoader:boolean;

  /**
   * Method to initialize Component
   * @param http  Sends an `HTTPRequest` and returns a stream of `HTTPEvents`.
   * @param urls Getting  apiurl from API url Component 
   * @param shared shared Service Component
   */
  constructor(private http: HttpClient, private urls: APIURLs, private shared: SharedService) {
    this.kycLoader=false;
  }

  /** show loader */
  showLoader(message) {
  //  console.log("show loader called")
    this.shared.loadingMessage=(message?message.split('.').join(''):"")||"";
    this.shared.isServiceHit = true;

  }

  /** Hide Loader */
  hideLoader() {
    if(this.kycLoader==false){
      this.shared.loadingMessage="";
      this.shared.isServiceHit = false;
    }
   
  }

   /**
 * Fetches encrypted Data from the server.
 * @param {any} request - The request object containing investor details.
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */

  encryptData(request: any): Observable<any> {
    const url = this.urls.getEncryptURL();
    this.showLoader("Saving your details.."); return this.http.post(url, request, { headers: this.getHeaders() }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

     /**
 * Fetches decrypted Data from the server.
 * @param {any} request - The request object containing investor details.
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */

  decryptData(request: any): Observable<any> {
    const url = this.urls.getDecryptURL();
    this.showLoader("Fetching details.."); return this.http.post(url, request, { headers: this.getHeaders() }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

/**
 * Fetches check For Existence Data from the server.
 * @param {any} request - The request object containing investor details.
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */

  checkForExistence(request: any): Observable<any> {
    const url = this.urls.getCheckExistenceURL();
    let payload = {
      PAN: request.PAN,
      mobile: null,
      clientId: request.clientId,
      both: request.both
    }
    this.showLoader("Checking if already exist.."); return this.http.post(url, payload, { headers: this.getHeaders(false,request.investorId) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

 /**
 * Fetches investor Data from the server.
 * @param {any} request - The request object containing investor details.
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */

  getInvestorById(investorId: string) {
    const url = this.urls.getInvestorByIdURL(investorId);
    this.showLoader("Fetching details.."); return this.http.get(url, { headers: this.getHeaders(false, investorId) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }


 /**
 * Fetches investor details from the server.
 * @param {any} request - The request object containing investor details.
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */
getInvestorDetails(request: any): Observable<any> {
  /** URL for fetching investor details */
  const url = this.urls.getInvDetailsURL();
  
  /** Displays loader while fetching investor details */
  this.showLoader("Fetching details..");

  /** Sends an HTTP POST request to fetch the investor details */
  return this.http.post(url, request, { headers: this.getHeaders() }).pipe(
    map((response: Response) => {
      /** Hides loader on successful response */
      this.hideLoader();
      return response;
    }),
    catchError((error: HttpErrorResponse) => {
      /** Hides loader on error and rethrows the error */
      this.hideLoader();
      return throwError(error);
    })
  );
}


/**
 * Fetches investor details from the server.
 * @param request - The request object containing investor details.
 * @param isForceProcess passing value of force process 
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */
  registerInvestor(request: any, isForceProcess: string): Observable<any> {
    const url = this.urls.getRegisterInvestorURL(isForceProcess);
    this.showLoader("Registering.."); return this.http.post(url, request, { headers: this.getHeaders() }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }
 
  /**
   * Fetches CVL from the server.
   * @param request  - The request object containing investor details.
   * @param investorId -passing investor id
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */

  fetchFromCVL(request: any, investorId?: string): Observable<any> {
    const url = this.urls.getPANDetailsURL();
    this.showLoader("Fetching from CVL.."); return this.http.post(url, request, { headers: this.getKYCHeaders() }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /**
   * Fetches city from the server.
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  retrieveLeadCityList(): Observable<any> {
    const url = this.urls.getLeadCityListURL();
    this.showLoader("Retrieving city list.."); 
    return this.http.get(url, { headers: this.getHeaders() }).pipe(
      map((response: Response) => {
        // this.hideLoader(); 
        return response;
      }), catchError((error: HttpErrorResponse) => {
        // this.hideLoader(); 
        return throwError(error);
      })
    )
  }

  /**
   * fetch city name from server
   * @param cityname passing city name
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  retrieveLeadCityListV2(cityname: any): Observable<any> {
    const url = this.urls.getLeadCityListURLV2(cityname);
    this.showLoader("Retrieving city list.."); 
    return this.http.get(url, { headers: this.getKYCHeaders() }).pipe(
      map((response: Response) => {
        this.hideLoader(); 
        return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); 
        return throwError(error);
      })
    )
  }

  /**
   * fetch investor detail from server
   * @param request - The request object containing investor details.
   * @param investorId - passing investor id
   * @param hideLoader -for loader
   * @param contactUpdationType - contact updation time
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  updateInvestor(request: any, investorId?: string,hideLoader?:boolean, contactUpdationType?:string): Observable<any> {
    const url = this.urls.getUpdateInvDetailsURL();
    if(!hideLoader)
    {this.showLoader("Saving your details..");}
    return this.http.post(url, request, { headers: contactUpdationType ? this.getcontactUpdationTypeHeaders(false, investorId, '', false, contactUpdationType) : this.getHeaders(false, investorId, '', false) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /**
   * delete investor detail from server
   * @param investorId passing investor id
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */

  deleteInvestor(investorId: string): Observable<any> {
    const url = this.urls.getDeleteInvestorURL(investorId);
    this.showLoader("Saving your details.."); return this.http.delete(url, { headers: this.getHeaders(false, investorId) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /**
   *  delete client from server
   * @param clientId passing client id 
   * @param investorId passing investor id
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */

  deleteClient(clientId: string, investorId?: string): Observable<any> {
    const url = this.urls.getDeleteClientIdURL(clientId);
    this.showLoader(""); return this.http.delete(url, { headers: this.getHeaders(false, investorId) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /**
   * recover investor detail
   * @param pan passing pan number 
   * @param mobileNumber passing mobile number
   * @param investorId passing investor id
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  recoverInvestor(pan: string, mobileNumber: string, investorId?: string): Observable<any> {
    const url = this.urls.getRecoverAccountURL(pan, mobileNumber);
    this.showLoader("Recovering information.."); return this.http.get(url, { headers: this.getHeaders(false, investorId) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /**
   * send otp 
   * @param pan passing pan number
   * @param investorId passing innvestor id
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */

  sendOTP(pan: string, investorId?: string): Observable<any> {
    const url = this.urls.getSendOTPURL(pan);
    this.showLoader("Sending OTP.."); return this.http.get(url, { headers: this.getHeaders(false, investorId) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /**
   *  validate OTP
   * @param otp  passing otp
   * @param newInvestorId passing investor id
   * @param pan passing pan number
   * @param investorId passing investor id
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  validateOTP(otp: string, newInvestorId: string, pan: string, investorId?: string): Observable<any> {
    const url = this.urls.getValidateOTPURL(otp, newInvestorId, pan);
    this.showLoader("Validating OTP.."); return this.http.get(url, { headers: this.getHeaders(false, investorId) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /**
   * fetching investor port 
   * @param request 
   * @param investorId 
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  portInvestor(request: any, investorId?: string): Observable<any> {
    const url = this.urls.getPortingURL();
    this.showLoader("Porting detail.."); return this.http.post(url, request, { headers: this.getHeaders(false, investorId) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /**
   * fetching bank listing
   * @param flag passing flag value
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  retrieveBankLists(flag?): Observable<any> {
    const url = this.urls.getBankListURL();
    this.showLoader(flag?"Retrieving bank details..":"Retrieving bank list.."); return this.http.get(url, { headers: this.getHeaders() }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /**
   * fetching bank detail
   * @param ifsc passing ifsc value
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  retrieveBankDetails(ifsc: string): Observable<any> {
    const url = this.urls.getBankDetailsURL(ifsc);
    this.showLoader("Retrieving bank details.."); return this.http.get(url, { headers: this.getHeaders() }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /**
   * fetching branch list
   * @param bank  passing bank name
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  retrieveBranchLists(bank: string): Observable<any> {
    const url = this.urls.getBranchListURL(bank);
    this.showLoader("Retrieving branch list.."); return this.http.get(url, { headers: this.getHeaders() }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }
  /**
   * fetching state nAME
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */

  retrieveStateLists(): Observable<any> {
    const url = this.urls.getStateListURL();
    this.showLoader("Retrieving state list.."); 
    return this.http.get(url, { headers: this.getHeaders() }).pipe(
      map((response: Response) => {
        // this.hideLoader(); 
        return response;
      }), catchError((error: HttpErrorResponse) => {
        // this.hideLoader(); 
        return throwError(error);
      })
    )
  }

  /**
   * FETCHING EDUCATION LIST
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  retrieveEducationLists(): Observable<any> {
    const url = this.urls.getEducationListURL();
    this.showLoader("Retrieving education list.."); return this.http.get(url, { headers: this.getHeaders() }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /**
   * fetching screen list
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  retrieveScreenLists(): Observable<any> {
    const url = this.urls.getScreenListURL();
    this.showLoader("Retrieving screen list.."); 
    return this.http.get(url, { headers: this.getHeaders() }).pipe(
      map((response: Response) => {
        // this.hideLoader(); 
        return response;
      }), catchError((error: HttpErrorResponse) => {
        // this.hideLoader(); 
        return throwError(error);
      })
    )
  }

  /**
   * update onboarding screen naME
   * @param request passing screen name
   * @param inverstorId passing investor id
   * @param hideLoader passing loader
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  updateOnboardingScreen(request: any, inverstorId?: string,hideLoader?:boolean): Observable<any> {
    const url = this.urls.getUpdateScreenURL();
    if(!hideLoader)
   { 
    //this.showLoader("Updating screen data..");
    this.showLoader("");
   } 
    return this.http.post(url, request, { headers: this.getHeaders(false, inverstorId || '') }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /**
   * fetching occupation list
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */

  retrieveOccupationLists(): Observable<any> {
    const url = this.urls.getOccupationListURL();
    // this.showLoader("Retrieving occupation list.."); 
    return this.http.get(url, { headers: this.getHeaders() }).pipe(
      map((response: Response) => {
        // this.hideLoader(); 
        return response;
      }), catchError((error: HttpErrorResponse) => {
        // this.hideLoader(); 
        return throwError(error);
      })
    )
  }

  /**
   * retrieve IncomeSlab Lists
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  retrieveIncomeSlabLists(): Observable<any> {
    const url = this.urls.getIncomeSlabListURL();
    this.showLoader("Retrieving income slab list.."); return this.http.get(url, { headers: this.getHeaders() }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /**
   * retrieve Country Lists
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  retrieveCountryLists(): Observable<any> {
    const url = this.urls.getCountryListURL();
    this.showLoader("Retrieving country list.."); 
    return this.http.get(url, { headers: this.getHeaders() }).pipe(
      map((response: Response) => {
        // this.hideLoader(); 
        return response;
      }), catchError((error: HttpErrorResponse) => {
        // this.hideLoader(); 
        return throwError(error);
      })
    )
  }
/**
 * generate IPV OTP
 * @param investorId passing investor id
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */
  generateIPVOTP(investorId?: string): Observable<any> {
    const url = this.urls.getIPVOTPURL();
    this.showLoader("Generating IPV OTP.."); return this.http.get(url, { headers: this.getHeaders(false, investorId) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /**
   * upload IPV
   * @param formData passing form Data
   * @param fileName passing file name
   * @param investorId passing investor id
   * @param hideLoader passing loader
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  uploadIPV(formData: FormData, fileName: string, investorId?: string,hideLoader?:boolean): Observable<any> {
    const url = this.urls.getUploadIPVURL(fileName);
    if(!hideLoader)
   { this.showLoader("Uploading IPV..");}
     return this.http.post(url, formData, { headers: this.getHeaders(false, investorId, null, true) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /**
   * update Onboarding Completion
   * @param isEsignFlag passing Esign flag
   * @param investorId  passing investor id
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  updateOnboardingCompletion(isEsignFlag: string, investorId?: string): Observable<any> {
    const url = this.urls.getOnboardCompleteURL(isEsignFlag);
    this.showLoader("Completing onboarding.."); return this.http.get(url, { headers: this.getHeaders(false, investorId) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /**
   * fetching Document
   * @param formData passing form Data
   * @param fileName passing file name
   * @param documentType passing document type
   * @param investorId passing investor id
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  uploadDoc(formData: FormData, fileName: string, documentType: string, investorId?: string): Observable<any> {
    const url = this.urls.getUploadDocURL(fileName, documentType);
    this.showLoader("Uploading documents.."); return this.http.post(url, formData, { headers: this.getHeaders(true, investorId) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /**
   * upload Documet
   * @param formData passing form data 
   * @param fileNames passing file name 
   * @param documentTypes passing document type
   * @param investorId passing investor id
   * @param hideLoader passing loader
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  uploadDocs(formData: FormData, fileNames: string, documentTypes: string, investorId?: string,hideLoader?:boolean): Observable<any> {
    const url = this.urls.getUploadDocsURL(fileNames, documentTypes);
    if(!hideLoader)
   {  this.showLoader("Uploading documents..");}
     return this.http.post(url, formData, { headers: this.getHeaders(true, investorId) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }
  /**
   * upload AOF Docs
   * @param formData passing Form data
   * @param investorId passing investor id
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */

  uploadAOFDocs(formData: FormData, investorId?: string): Observable<any> {
    const url = this.urls.getUploadAofURL();
    this.showLoader("Uploading AOF documents.."); return this.http.post(url, formData, { headers: this.getHeaders(true, investorId) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /**
   * delete Nominee
   * @param investorId passing investor id
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  deleteNominee(investorId: string): Observable<any> {
    const url = this.urls.getDeleteNomineeURL(investorId);
    this.showLoader("Saving your details.."); return this.http.delete(url, { headers: this.getHeaders(true, investorId) }).pipe(map((response: Response) => {
      this.hideLoader(); return response;
    }), catchError((error: HttpErrorResponse) => {
      this.hideLoader(); return throwError(error);
    })
    )
  }
  /**
   * Delete Segment
   * @param investorId passing investor id 
   * @param hideLoader boolean loader
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */

  deleteSegments(investorId: string,hideLoader?:boolean): Observable<any> {
    const url = this.urls.getDeleteSegmentURL(investorId);
    if(!hideLoader)
   { this.showLoader("Saving your details..");}
     return this.http.delete(url, { headers: this.getHeaders(true, investorId) }).pipe(map((response: Response) => {
      this.hideLoader(); return response;
    }), catchError((error: HttpErrorResponse) => {
      this.hideLoader(); return throwError(error);
    })
    )
  }
  /**
   * Migration document
   * @param sourceInvestor passing investor source
   * @param destinationInvestor getting destination of investor 
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */

  migrateDocuments(sourceInvestor: string, destinationInvestor: string): Observable<any> {
    const url = this.urls.getMigrateDocURL(sourceInvestor, destinationInvestor);
    this.showLoader("Migrating documents.."); return this.http.post(url, null, { headers: this.getHeaders(false, destinationInvestor) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }
  /**
   * Generate Form
   * @param esignConsent {Observable<any>} An observable that emits the server's response or an error.
   * @param investorId passing investor id
   * @param isAccountClosure boolean account closuere 
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */

  generateForms(esignConsent: string, investorId?: string,isAccountClosure?:boolean): Observable<any> {
    const url = this.urls.getGenerateFormsURL(esignConsent)+(isAccountClosure?'&isAccountClosure=true':'');
    this.showLoader("Generating forms.."); return this.http.get(url, { headers: this.getHeaders(false, investorId) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }
  /**
   * through leader getting investor detail
   * @param leadId passing lead id
   * @param dontInitializeLoader loader
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */

  getInvestorByLeadId(leadId: string,dontInitializeLoader?: boolean) {
    const url = this.urls.getInvestorByLeadIdURL(leadId);
    if (!dontInitializeLoader)
      this.showLoader("Fetching details..");
    return this.http.get(url, { headers: this.getHeaders(false, leadId) }).pipe(
      map((response: Response) => {
        if (!dontInitializeLoader)
          this.hideLoader(); 
        return response;
      }), catchError((error: HttpErrorResponse) => {
        if (!dontInitializeLoader)
          this.hideLoader(); 
        return throwError(error);
      })
    )
  }

  /**
   * Sending onboarding otp
   * @param payload passing payload
   * @param isAlphabee boolean alphabee
   * @param investorId  passing investor id
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  sendOnboardOTP(payload?:any, isAlphabee?:boolean, investorId?:string) {
    const url = this.urls.getSendOnboardOTPURL();
    this.showLoader("Sending OTP.."); return this.http.post(url,payload, { headers: this.getHeadersForOtp(isAlphabee,investorId) }).pipe(
      map((response: any) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }
  /**
   * verify onbopardinng otp
   * @param payload passing payload
   * @param investorId passing investor id
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */

  verifyOnboardOTP(payload: any, investorId?:string) {
    const url = this.urls.getVerifyOnboardOTPURL();
    this.showLoader("Verifying OTP.."); return this.http.post(url,payload, { headers: this.getHeaders(false, investorId) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /**
   * Brokerage by refer code
   * @param referCode passing refer code
   * @param investorId passing investor id
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  getBrokerageByReferCode(referCode: string, investorId?: string) {
    const url = this.urls.getBrokerageByReferCodeURL(referCode);
    this.showLoader("Getting brokerage.."); return this.http.get(url, { headers: this.getHeaders(false, investorId) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }
  /**
   * get document base url
   * @param investorId passing investor id
   * @param filePath passing file path
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */

  getDocBaseURL(investorId: string, filePath: string) {
    let url = this.urls.getDocBaseURL(investorId, filePath);
    return url ? url + ('?q=' + new Date().valueOf()) : url;
  }

  /**
   * generate form url
   * @param fileName getting file name
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  getGeneratedFormURL(fileName: string) {
    return this.urls.getGeneratedFormURL(fileName);
  }

  /**
   * getting brokerage data 
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  getBrokerageData() {
    const url = this.urls.getBrokerageDataURL();
    this.showLoader("Getting brokerage data.."); return this.http.get(url).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }
/**
 * fetching Brokerage 
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */
  getBUBrokerage(){
    const url = this.urls.getBUBrokerageDataURL();
    this.showLoader("Getting brokerage.."); return this.http.get(url).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }
/**
 * get penny drop header
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */
  private getPennyDropHeaders(): HttpHeaders {
    let headers = new HttpHeaders({
      'Accept': 'application/json',
      'x-api-key': environment.xapiKeys.commonKey,
    });
    return headers;
  }
/**
 * verifying penny drop count
 * @param request passing payload
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */
  verifyPennyDropAccount(request) {
    const url = this.urls.getpennyDropURL();
    this.showLoader("Verifying your Bank details..."); return this.http.post(url,request, { headers: this.getPennyDropHeaders() }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }
/**
 * recovering Client
 * @param pan passing pan number
 * @param investorId passing investor id
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */
  recoverClient(pan: string, investorId?: string) {
    const url = this.urls.getRecoverClientURL(pan);
    this.showLoader("Recovering client.."); return this.http.get(url, { headers: this.getHeaders(false, investorId) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }
/**
 * respond Issue
 * @param request passing payload
 * @param source passing source
 * @param investorId investorId
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */
  respondIssue(request: any, source: string, investorId?: string) {
    const url = this.urls.getRespondIssueURL(source);
    this.showLoader("Responding to an issue.."); return this.http.post(url, request, { headers: this.getHeaders(false, investorId) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }
/**
 * Location Detail
 * @param latlng location wise language
 * @param investorId passing investor id
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */
  getLocationDetail(latlng: string, investorId?: string) {
    const url = this.urls.getLocationURL(latlng);
    this.showLoader("Getting location detail.."); return this.http.get(url).pipe(map((response: Response) => {
      this.hideLoader(); return response;
    }), catchError((error: HttpErrorResponse) => {
      this.hideLoader(); return throwError(error);
    })
    )
  }
/**
 * language data
 * @param lang  pass language
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */
  getLanguageData(lang: string) {
    const url = this.urls.getLangDataURL(lang);
    this.showLoader("Getting langauage data.."); return this.http.get(url).pipe(map((response: Response) => {
      this.hideLoader();
       return response;
    }), catchError((error: HttpErrorResponse) => {
      this.hideLoader(); 
      return throwError(error);
    })
    )
  }
/**
 * get header 
 * @param isMultipart isMultipart
 * @param investorId investorId
 * @param businessUnit businessUnit
 * @param isBlank isBlank
 * @param contactUpdationType contactUpdationType
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */
  private getHeaders(isMultipart?: boolean, investorId?: string, businessUnit?: string, isBlank?: boolean,contactUpdationType?: string): HttpHeaders {
    businessUnit = businessUnit || this.urls.getBusinessUnit();
    /** header */
    let headers ;
    
    if(sessionStorage.getItem('ModifyFiles')){
      headers = new HttpHeaders({
        'ticket': this.urls.getAuthorizationHeader(businessUnit) || '',
        'userid': 'Onboarding',
        'investorid': investorId || '',
        'businessunit': businessUnit || '',
        'from': (location.href || '') + '_' + (this.urls.version || ''),
        'Accept': 'application/json',
        "modificationType": sessionStorage.getItem('ModifyFiles')
      });
    }else{
      headers = new HttpHeaders({
        'ticket': this.urls.getAuthorizationHeader(businessUnit) || '',
        'userid': 'Onboarding',
        'investorid': investorId || '',
        'businessunit': businessUnit || '',
        'from': (location.href || '') + '_' + (this.urls.version || ''),
        'Accept': 'application/json',
       
      });
    }
    if (!isBlank) {
      headers.set('Content-Type', isMultipart ? 'multipart/form-data' : 'application/json');
    }
    if (contactUpdationType) {
      headers.set('contactUpdationType', contactUpdationType);
    }
    return headers;
  }
  /**
   * duplicate lead
   * @param request passing payload
   * @param id passing id
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */

  updateDuplicateLeadAgainstPanNum(request: any,id): Observable<any> {
    const url = this.urls.getupdateDuplicateLidAgainstPanURL();
    this.showLoader("Saving your details.."); return this.http.post(url, request, { headers: this.getHeaders(false,id) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }
/**
 * getting referal id
 * @param id passing id
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */
  getReferralDetails(id: any): Observable<any> {
    const url = this.urls.getreferralDetailsURL(id);
    this.showLoader("Getting referral detail.."); return this.http.get(url, { headers: this.getHeaders() }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /**
   * fetching header got otp
   * @param isAlphabee boolean value for isalphabee
   * @param investorId passing investor id
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */

  private getHeadersForOtp(isAlphabee, investorId?: string): HttpHeaders {
    let businessUnit = this.urls.getBusinessUnit();
    let headers;
    if (isAlphabee) {
      headers = new HttpHeaders({
        'ticket': this.urls.getAuthorizationHeader() || '',
        'userid': 'Onboarding',
        'investorid': investorId || '',
        'businessunit': businessUnit || '',
        'from': (location.href || '') + '_' + (this.urls.version || ''),
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'originalSource': 'ALPHABEE'
      });
    } else {
      headers = new HttpHeaders({
        'ticket': this.urls.getAuthorizationHeader() || '',
        'userid': 'Onboarding',
        'investorid': investorId || '',
        'businessunit': businessUnit || '',
        'from': (location.href || '') + '_' + (this.urls.version || ''),
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      });
    }
    return headers;
  }

  /**
   * fetching bank detail;
   * @param request passing payload
   * @param investorId passing investor id
   * @returns {Observable<any>} An observable that emits the server's response or an error. 
   */

  bankBazaarUpdateDetails(request: any, investorId: any) {
    const url = this.urls.getBankBazaarUpdateDetailsURL();
    this.showLoader("Getting bank bazaar detail.."); return this.http.post(url, request, { headers: this.getHeaders(false, investorId) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }
/**
 * upload bank document
 * @param formData passing formdaata
 * @param investorId passing investor id
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */
  uploadBankBazaarDocs(formData: FormData, investorId: any): Observable<any> {
    const url = this.urls.getBankBazaarUploadDocsURL();
    this.showLoader("Upload bank bazaar documents.."); return this.http.post(url, formData, { headers: this.getHeaders(true, investorId) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /**
   * delete new lead againt pan 
   * @param request passing payload
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  deleteNewLeadAgainstPanNum(request: any): Observable<any> {
    const url = this.urls.getdeletNewLeadAgainstPanURL();
    this.showLoader("Saving your details.."); return this.http.post(url, request, { headers: this.getHeaders(false) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /**
   * fetching digio document upload
   * @param investorId passing investor id
   * @param formName passing form name
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  digioDocUpload(investorId: any, formName): Observable<any> {
    let url = this.urls.getDigioDocUploadUrl();
    url = url.replace('$formName', formName);
    this.showLoader("Fetching Document ID.."); return this.http.get(url, { headers: this.getHeaders(false, investorId) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }
  /**
   * identify unique email or mobile
   * @param request passing payload
   * @param id passing id
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  checkUniqueMobileAndEmail(request: any,id): Observable<any> {
    const url = this.urls.getUniqueCheckURL();
    this.showLoader("Checking your details.."); return this.http.post(url, request, { headers: this.getHeaders(false,id,'JF') }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }
/**
 * Digio Document Download
 * @param investorId passing investor id
 * @param pan passing pan
 * @param docId passing document id
 * @param formName passing form name
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */
  digioDocDownload(investorId: any, pan, docId, formName): Observable<any> {
    const url = this.urls.getDigioDocDownloadUrl(pan, docId, formName);
    this.showLoader("Esign in progress.."); return this.http.get(url, { headers: this.getHeaders(false, investorId) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }
/**
 * generate onboarding base url
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */

  getOnboardingBaseURL(){
    return location.origin
  }
/**
 * fetching IPV sms
 * @param request passing payload
 * @param id passing id
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */
  sendIPVSMS(request: any,id): Observable<any> {
    const url = this.urls.geIPVSmsURL();
    this.showLoader("Sending IPV link.."); return this.http.post(url, request, { headers: this.getHeaders(false,id) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }
/**
 * header for kyc
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */
  private getKYCHeaders(): HttpHeaders {
    let headers = new HttpHeaders({
      'x-api-key': environment.xapiKeys.commonKey
    });
    return headers;
  }
/**
 * Generate KYC
 * @param request passing payload 
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */
  generateKYC(request: any): Observable<any> {
    const url = this.urls.getGenerateKYCURL();
    this.kycLoader=true;
    this.showLoader("Generating KYC..."); return this.http.post(url, request, { headers: this.getKYCHeaders() }).pipe(
      map((response: Response) => {
        this.kycLoader=false;
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.kycLoader=false;
        this.hideLoader(); return throwError(error);
      })
    )
  }
/**
 * kyc saved
 * @param request passing payload
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */
  saveKYC(request: any): Observable<any> {
    const url = this.urls.getSaveKYCURL();
    this.showLoader("Saving KYC Details.."); return this.http.post(url, request, { headers: this.getKYCHeaders() }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }
/**
 * fetching environment type
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */
  getEnvironmentType() {
    return this.urls.getEnvironment();
  }

  /**
   * fetching investor detail by pan
   * @param value passing form value
   * @param businessInfo passing bussiness
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  getInvestorByPanOrClient(value: string, businessInfo?: any) {
    const url = this.urls.getInvestorByPanClientURL(value, businessInfo)
    this.showLoader("Fetching details.."); return this.http.get(url, { headers: this.getHeaders(false, "1", businessInfo) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }
/**
 * send otp 
 * @param bu passing business unit 
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */
  sendOTPRespond(investorId: string, bu: string) {
    // investorId, purpose
    const url = this.urls.getSendRespondOTPURL();
    this.showLoader("Sending OTP.."); return this.http.get(url, { headers: this.getHeaders(false, investorId,bu) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /**
   * validate otp
   * @param investorId passing investor id 
   * @param otp passing otp
   * @param bu passing businessunit
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  verifyOTP(investorId: string, otp: string, bu: string) {
    const url = this.urls.getVerifyRespondOTPURL(otp);
    this.showLoader("Verifying OTP.."); return this.http.get(url, { headers: this.getHeaders(false, investorId, bu) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /**
   * validate refer id
   * @param referralCode passing refer id
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  checkRefercodeValidation(referralCode: string) {
    const url = this.urls.getReferralValidationURL(referralCode)
    this.showLoader("Checking your details.."); return this.http.get(url, { headers: this.getHeaders() }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /**
   * upload Documnents
   * @param formData passing formdata 
   * @param fileNames passing file name
   * @param documentTypes passing document type
   * @param investorId passing investor id
   * @param hideLoader loader check
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  uploadDocsOffline(formData: FormData, fileNames: string, documentTypes: string, investorId?: string,hideLoader?:boolean): Observable<any> {
    const url = this.urls.getUploadDocsURL(fileNames, documentTypes);
    if(!hideLoader)
   {  this.showLoader("Documents are being uploaded .Please wait for some time till it process..");}
     return this.http.post(url, formData, { headers: this.getHeaders(true, investorId) }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /**
   * fetching check PanValidate KYC
   * @param request passing payload
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  checkPanValidateKYC(request: any): Observable<any> {
    const url = this.urls.getPanValidateKYCURL();
    this.showLoader("Checking PAN Details.."); return this.http.post(url, request, { headers: this.getKYCHeaders() }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }
/**
 * conntact upgradation header
 * @param isMultipart boolean value pass
 * @param investorId passing investor id
 * @param businessUnit passing bussiness  unit
 * @param isBlank empty opr not
 * @param contactUpdationType  passing contact updation type
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */
  private getcontactUpdationTypeHeaders(isMultipart?: boolean, investorId?: string, businessUnit?: string, isBlank?: boolean,contactUpdationType?: string): HttpHeaders {
    businessUnit = businessUnit || this.urls.getBusinessUnit();
    let headers = new HttpHeaders({
      'ticket': this.urls.getAuthorizationHeader(businessUnit) || '',
      'userid': 'Onboarding',
      'investorid': investorId || '',
      'businessunit': businessUnit || '',
      'from': (location.href || '') + '_' + (this.urls.version || ''),
      'Accept': 'application/json',
      'contactUpdationType': contactUpdationType || 'both'
    });
    if (!isBlank) {
      headers.set('Content-Type', isMultipart ? 'multipart/form-data' : 'application/json');
    }
    return headers;
  }
/**
 * fetching education list
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */
  retrieveEducationListsV2(): Observable<any> {
    const url = this.urls.getEducationListV2URL();
    this.showLoader("Retrieving education list.."); return this.http.get(url, { headers: this.getKYCHeaders() }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }
/**
 * fetching check Unique  Mobile And Email Offline
 * @param request passing payload
 * @param investorId passing investor id
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */
  checkUniqueMobileAndEmailOffline(request: any, investorId?: string): Observable<any> {
    const url = this.urls.getUniqueCheckOfflineURL();
    this.showLoader("Checking your details.."); return this.http.post(url, request, { headers: this.getHeaders(false, (investorId || '1'), 'JF') }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }
  /**
   * header for adhaar masking 
   * @param isMultipart boolean for is multi part
   * @param investorId passing investor id
   * @param businessUnit passing business unit
   * @param isBlank empty or not
   * @param contactUpdationType  passing contact Updation Type
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
 private getmaskHeaders(isMultipart?: boolean, investorId?: string, businessUnit?: string, isBlank?: boolean,contactUpdationType?: string): HttpHeaders {
    businessUnit = businessUnit || this.urls.getBusinessUnit();
    let headers = new HttpHeaders({
      'ticket': this.urls.getAuthorizationHeader(businessUnit) || '',
      'userid': 'Onboarding',
      'investorid': investorId || '',
      'businessunit': businessUnit || '',
      'from': (location.href || '') + '_' + (this.urls.version || ''),
      'Accept': 'application/json',
      'x-api-key': environment.xapiKeys.commonKey
    });
    
    if (!isBlank) {
      headers.set('Content-Type', isMultipart ? 'multipart/form-data' : 'application/json');
    }
    if (contactUpdationType) {
      headers.set('contactUpdationType', contactUpdationType);
    }
    return headers;
  }
  /**
   * adhaar masking check
   * @param formDatamasking passing form Data masking
   * @param fileNames passing file Names
   * @param documentTypes passing document Types
   * @param investorId passing investor Id
   * @param hideLoader passing loader
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */

  maskingAdhaar(formDatamasking: FormData, fileNames: string, documentTypes: string, investorId?: string,hideLoader?:boolean): Observable<any> {
    const url = this.urls.getAdhaarMasking();
    if(!hideLoader)
   {  this.showLoader("Uploading documents..");}
     return this.http.post(url,formDatamasking, { headers: this.getmaskHeaders(true, investorId) }).pipe( 
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }
/**
 * fetching state list
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */
  retrieveStateListsV2(): Observable<any> {
    const url = this.urls.getStatesListURLV2();
    this.showLoader("Retrieving state list.."); 
    return this.http.get(url, { headers: this.getKYCHeaders() }).pipe(
      map((response: Response) => {
        // this.hideLoader(); 
        return response;
      }), catchError((error: HttpErrorResponse) => {
        // this.hideLoader(); 
        return throwError(error);
      })
    )
  }
  /**
   * fetching access token
   * @param data passing payload
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */

  getAccessTokenURL(data: any): Observable<any> {
    const url = this.urls.generateAccessTokenURL();
    this.showLoader("Generating Access Token..");
    return this.http.post(url,data,{headers: this.getKYCHeaders()}).pipe(
      map((response: Response) => {
        this.hideLoader();
        console.log('inside success')
        return response;
      }),catchError((error: HttpErrorResponse) => {
        console.log('inside error')
        this.hideLoader();
        return throwError(error)
      })
    )
  }
  /**
   * validation
   * @param data passing payload 
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  retrieveValidationURL(data: any): Observable<any> {
    const url = this.urls.getValidationURL();
    this.showLoader("Validating Data.."); 
    return this.http.post(url,data, { headers: this.getKYCHeaders() }).pipe(
      map((response: Response) => {
        this.hideLoader(); 
        return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); 
        return throwError(error);
      })
    )
  }

  /**
   * checking signature 
   * @param data sign payload
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  checkSignatureOcrURL(data: any): Observable<any> {
    const url = this.urls.getSignatureOcrURL();
    this.showLoader("Loading Data.."); 
    return this.http.post(url,data, { headers: this.getKYCHeaders() }).pipe(
      map((response: Response) => {
        this.hideLoader(); 
        return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); 
        return throwError(error);
      })
    )
  }

  /**
   * fetching secure file
   * @param data passling payload
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  getSecureFileDownload(data: any): Observable<any> {
    const url = this.urls.getSecureFileDownloadURL();
    let headers = this.getKYCHeaders();
        headers['Content-Type']= 'application/json',
        headers['Accept']= 'application/json'      
    this.showLoader("Loading Data..");
    return this.http.post(url,data, { headers: headers, responseType: 'blob' as 'json'})
    .pipe(map((response: any) => {
      this.hideLoader();
      return response;
    }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); 
        return throwError(error);
      })
    ); 
  }
/**
 * Update  InvestorDP Preference
 * @param data  passing paYLOAD
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */
  getUpdateInvestorDPPreference(data: any): Observable<any> {
    const url = this.urls.getUpdateDPPreferenceURL();
    this.showLoader("Loading Data.."); 
    return this.http.post(url,data, { headers: this.getKYCHeaders() }).pipe(
      map((response: Response) => {
        this.hideLoader(); 
        return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); 
        return throwError(error);
      })
    )
  }

/**
 * get Setter Investor DP Preference
 * @param investorId passing investor id
 * @returns {Observable<any>} An observable that emits the server's response or an error.
 */
   getSetterInvestorDPPreference(investorId: string): Observable<any> {
    const url = this.urls.getSetterDPPreferenceURL(investorId);
    this.showLoader("Loading Data.."); 
    return this.http.get(url, { headers: this.getKYCHeaders() }).pipe(
      map((response: Response) => {
        this.hideLoader(); 
        return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); 
        return throwError(error);
      })
    )
  }
  /**
   * fetching bank
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */

  getAllBanksWithLogo(): Observable<any>{
    const url = this.urls.getAllBanksURL();
    this.showLoader("Loading Data..");
    return this.http.get(url, { headers: this.getKYCHeaders() }).pipe(
      map((response: Response) => {
        this.hideLoader(); 
        return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); 
        return throwError(error);
      })
  )}

  /**
   * fetching digio event log
   * @param request passing digio event log 
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */

  digioEventsLog(request: any): Observable<any> {
    const url = this.urls.getDigioEventsUrl();
    // this.showLoader("Saving KYC Details.."); 
    return this.http.post(url, request, { headers: this.getKYCHeaders() }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /**
   * validate email
   * @param request passing email
   * @returns {Observable<any>} An observable that emits the server's response or an error.
   */
  ValidateEmail(request: any) : Observable<any> {
    const url  = this.urls.getValidateEmail();
    this.showLoader("Loading Data..");
    return this.http.post(url,request,{ headers: this.getKYCHeaders() }).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }

  /** Account Aggregator  generate link API*/

  GenerateLink(request:any)  : Observable<any> {
    const url = this.urls.generateRequest();
    this.showLoader("Loading Data .. ");
    return this.http.post(url,request,{headers : this.getKYCHeaders()}).pipe(
      map((response:Response)=>{
        this.hideLoader()
          return response;
        
      }),catchError((error: HttpErrorResponse)=>{
        this.hideLoader(); return throwError(error);

      })
    )
  }


}
